export default "__VITE_ASSET__CDQymbql__"